import { render, staticRenderFns } from "./SetQuestion.vue?vue&type=template&id=60675830&scoped=true"
import script from "./SetQuestion.vue?vue&type=script&lang=js"
export * from "./SetQuestion.vue?vue&type=script&lang=js"
import style0 from "./SetQuestion.vue?vue&type=style&index=0&id=60675830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60675830",
  null
  
)

export default component.exports